import axios from './axios'
import { ElLoading } from 'element-plus'
export function getRecordList (flag, param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/pos_front/record_list/' + flag, param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}
/**
 * 修改消费单 关联单号
 * @param {} param
 * @param {*} callbackFun
 */
export function operConsumeBill (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/pos_front/record_oper/3', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}
export function operRedWrite (flag, param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/pos_front/record_oper/' + flag, param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}
